<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container>
      <v-row class="mb-4" align="center">
        <v-col cols="auto">
          <h2 v-if="roomData">
            {{ $t("basics.edit", { type: $t("basics.room") }) }}
          </h2>
          <h2 v-else>
            {{ $t("basics.new", { type: $t("basics.room") }) }}
          </h2>
        </v-col>
      </v-row>

      <v-form ref="roomEditForm">
        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat :rules="[requiredRule, max256]" v-model="name"
              :label="$t('basics.name') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>


        <v-row>
          <v-col cols="12">
            <v-combobox v-model="premise" :items="availPremises" :label="$t('basics.premise')" variant="outlined"
              item-title="name" item-value="name" return-object :rules="[requiredRule, validObject]" autocomplete="off"
              :readonly="readonly"></v-combobox>
          </v-col>
        </v-row>


        <v-row>
          <v-col cols="auto">
            <color-picker v-model:pureColor="colorCode" />
          </v-col>
          <v-col>
            {{ $t('basics.calendarColorCode') }}
          </v-col>
        </v-row>

        <v-row v-if="!readonly">
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" @click="confirm()" ref="confirmButton" style="width: 100%">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "roomEditDrawer",
  props: ["roomData", "refreshDisplay", "readonly"],
  emits: ["close"],

  data() {
    return {
      name: undefined,
      premise: undefined,
      colorCode: undefined,

      availPremises: [],

      requiredRule: (value) => !!value || this.$i18n.t("messages.required"),
      validObject: (value) =>
        !value ||
        typeof value == "object" ||
        this.$i18n.t("messages.validSelectionrequired"),
      max256: (value) =>
        !value || value.length <= 256 || this.$i18n.t("messages.tooLong", { count: 256 }),
      max5: (value) =>
        !value || value.length <= 5 || this.$i18n.t("messages.tooLong", { count: 5 }),
      max5000: (value) =>
        !value ||
        value.length <= 5000 ||
        this.$i18n.t("messages.tooLong", { count: 5000 }),
    };
  },

  components: {
  },

  watch: {
    refreshDisplay() {
      this.setValues();
    },
  },

  methods: {
    rgbStringToHex(rgbString) {
      if (!rgbString) {
        return null;
      }
      const match = rgbString.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      if (!match) return null;

      const [, r, g, b] = match.map(Number);
      return (
        "#" +
        [r, g, b]
          .map((x) => {
            const hex = x.toString(16);
            return hex.length === 1 ? "0" + hex : hex;
          })
          .join("")
      );
    },
    hexToRgbString(hex) {
      // Remove leading # if present
      hex = hex.replace(/^#/, "");

      // Handle shorthand hex (#abc)
      if (hex.length === 3) {
        hex = hex
          .split("")
          .map((c) => c + c)
          .join("");
      }

      if (hex.length !== 6) return null;

      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);

      return `rgb(${r}, ${g}, ${b})`;
    },
    async confirm() {
      const { valid } = await this.$refs.roomEditForm.validate();

      if (valid) {
        let formData = {};
        formData.name = this.name;
        formData.premise = this.premise.id;
        formData.color_code = this.rgbStringToHex(this.colorCode)



        if (this.roomData) {
          formData.id = this.roomData.id;
          this.patchData(formData);
        } else {
          this.postData(formData);
        }
      }
    },
    postData(formData) {
      this.axios
        .post(this.axios.defaults.baseURL + "calendar/rooms/post/", formData)
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },

    patchData(formData) {
      this.axios
        .patch(
          this.axios.defaults.baseURL + "calendar/rooms/patch/" + formData.id,
          formData
        )
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    setValues() {
      if (this.roomData) {
        this.name = this.roomData.name;
        this.premise = this.roomData.premise;
        this.colorCode = this.hexToRgbString(this.roomData.color_code)
      } else {
        this.name = undefined;
        this.premise = undefined;
        this.colorCode = this.hexToRgbString("#aba289") //random default
      }
    },
    fetchPremises() {
      this.axios.get(this.axios.defaults.baseURL + "localization/premises/?size=10000")
        .then((resp) => {
          this.availPremises = resp.data.results
        })

        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    }
  },

  mounted() {
    this.fetchPremises()
  },
};
</script>
